
<template>
  <div class="full-container" id="star_sale">
    <SearchBar></SearchBar>
    <div class="full-container" v-loading="listLoading">
      <div class="main-container clearfix star_cont">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-show="!yunModel">
          <el-breadcrumb-item>
            <router-link to="/">{{ $t("header.menu.home") }}</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t("header.menu.sales") }}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>{{ $t("footer.sales") }}</el-breadcrumb-item> -->
        </el-breadcrumb>
        <div class="star_main">
          <div class="logo_title">
            <div
              class="limit_logo"
              v-lazy:background-image="
                '//doc.yctop.com/yc/static/2020-9-14/hot-2.png'
              "
            ></div>
          </div>
          <div id="promotionlist">
            <div
              shadow="hover"
              class="item fl"
              v-for="item in limittime_discounts"
            >
              <router-link
                v-if="item.status != 'OFF' && item.productPercentage != '100'"
                class="promoteItem clearfix"
                :target="yunModel ? '_self' : '_blank'"
                :to="{
                  name: 'ProductDetailPage',
                  query: {
                    productcode: item.productCode,
                    pricecode: item.priceCode,
                    productType: 'FLA',
                    departure: item.departure,
                    destination: item.destination,
                    yunModel: yunModel
                  }
                }"
              >
                <img
                  v-lazy="item.thumb"
                  class="promotionimage"
                  alt=""
                />
                <div class="item_content">
                  <div class="promotion_title">
                    <span class="promotion-name"
                      >{{ item.departure }}-{{ item.destination }}</span
                    >
                    <span class="promotion_allIn fr">{{
                      item.carrierId ? item.carrierId : ""
                    }}</span>
                    <span class="mp_bg"></span>
                  </div>
                  <div class="rebatesingle" v-if="!!item.productDescription">
                    <div class="left_logo"></div>
                    <p>{{ item.productDescription }}</p>
                  </div>
                  <div class="promotion_price">
                    <div class="p_left fl">
                      <p class="price_cur">
                        <b>CNY ¥</b>
                        <span>{{ item.q5Price }}</span>
                        <span class="qi" style="font-size: 12px;"
                          >&nbsp;/KG {{ $t("query.begin") }}</span
                        >
                      </p>
                      <!-- <div class="originalprice-line"> {{item.marketPrice}}/KG </div> -->
                      <div
                        class="product_tips promotion_tips"
                        v-if="!!item.productTitle"
                      >
                        {{ item.productTitle }}
                      </div>
                    </div>
                    <div class="p_right fr" v-if="!!item.endDateTime">
                      <p>
                        ETD：<span style="margin-left:2px;">{{
                          item.endDateTime
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="lave">
                    <div class="lave_left fl">
                      <p>
                        {{ $t("query.sold")
                        }}{{
                          !!item.productPercentage
                            ? item.productPercentage + "%"
                            : "0%"
                        }}
                      </p>
                      <el-progress
                        :percentage="item.productPercentage"
                        color="#D0021B"
                        :show-text="false"
                      ></el-progress>
                    </div>

                    <div class="right fr">
                      <!-- <i class="iconfont el-icon-eft-bianzu4"></i> -->
                      {{ $t("query.surplus") }}
                      <span
                        v-if="!!item.transportSurplusVolume"
                        style="margin-left:4px;"
                        >{{ item.transportSurplusVolume }}m³</span
                      >
                      <span
                        v-if="!!item.transportSurplusWeight"
                        style="margin-left:4px;"
                        >{{ item.transportSurplusWeight }}KG</span
                      >
                    </div>
                  </div>
                </div>
              </router-link>
              <router-link
                v-if="item.status == 'OFF' || item.productPercentage == 100"
                class="promoteItem clearfix"
                :target="yunModel ? '_self' : '_blank'"
                :to="{
                  name: 'ProductDetailPage',
                  query: {
                    productcode: item.productCode,
                    pricecode: item.priceCode,
                    productType: 'FLA',
                    departure: item.departure,
                    destination: item.destination,
                    yunModel: yunModel
                  }
                }"
              >
                <img
                  v-lazy="item.thumb"
                  class="promotionimage"
                  alt=""
                />

                <div class="item_content">
                  <div class="promotion_title">
                    <span class="promotion-name"
                      >{{ item.departure }}-{{ item.destination }}</span
                    >
                    <span class="promotion_allIn fr airlinefail">{{
                      item.carrierId ? item.carrierId : ""
                    }}</span>
                    <span class="mp_bg"></span>
                  </div>
                  <div
                    class="rebatesingle out"
                    v-if="!!item.productDescription"
                  >
                    <div class="left_logo"></div>
                    <p>{{ item.productDescription }}</p>
                  </div>
                  <div class="over_logo">
                    <img
                      v-if="item.productPercentage == 100"
                      v-lazy="
                        '//doc.yctop.com/yc/static/2020-9-11/soldout.png'
                      "
                      alt=""
                    />
                    <img
                      v-else
                      v-lazy="'//doc.yctop.com/yc/static/2020-9-11/end.png'"
                      alt=""
                    />
                  </div>
                  <div class="promotion_price">
                    <div class="p_left fl">
                      <p class="price_cur fail">
                        <b>CNY ¥</b>
                        <span>{{ item.q5Price }}</span>
                        <span class="qi" style="font-size: 12px;"
                          >&nbsp;/KG {{ $t("query.begin") }}</span
                        >
                      </p>
                      <!-- <div class="originalprice-line"> {{item.marketPrice}}/KG </div> -->
                      <div
                        class="product_tips promotion_tips fail_tips"
                        v-if="!!item.productTitle"
                      >
                        {{ item.productTitle }}
                      </div>
                    </div>
                    <div class="p_right soldout fr" v-if="!!item.endDateTime">
                      <p>
                        ETD：<span style="margin-left:2px;">{{
                          item.endDateTime
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="lave">
                    <div class="lave_left fl">
                      <p>
                        {{ $t("query.sold")
                        }}{{
                          !!item.productPercentage
                            ? item.productPercentage + "%"
                            : "0%"
                        }}
                      </p>
                      <el-progress
                        :percentage="item.productPercentage"
                        color="#DDDDDD"
                        :show-text="false"
                      ></el-progress>
                    </div>

                    <div class="right fr">
                      <!-- <i class="iconfont el-icon-eft-bianzu4"></i> -->
                       {{ $t("query.surplus") }}
                      <span
                        v-if="!!item.transportSurplusVolume"
                        style="margin-left:4px;"
                        >{{ item.transportSurplusVolume }}m³</span
                      >
                      <span
                        v-if="!!item.transportSurplusWeight"
                        style="margin-left:4px;"
                        >{{ item.transportSurplusWeight }}KG</span
                      >
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div v-if="!listLoading && limittime_discounts.length <= 0">
          <el-row class="notcont">
            <el-col :span="8">
              <img v-lazy="'//doc.yctop.com/v3/images/temp/notcont.jpg'" alt />
            </el-col>
            <el-col :span="10">
              <h1 class="com_bq">{{ $t("notfound.no_p1") }}</h1>
              <div>
                <span>{{ $t("notfound.no_p2") }}</span>
                <b>400-666-9551</b>
              </div>
              <div>
                <span>{{ $t("notfound.no_p3") }}</span>
                <el-button
                  type="primary"
                  class="onlinekf"
                  icon="iconfont el-icon-eft-zaixiankefu-youcang"
                  @click="openKF5Support"
                  >{{ $t("notfound.no_p4") }}</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped="true">
@import "~@/assets/css/view/product/starList.css";
</style>
<script type="babel">
import SearchBar from "@/components/searchBar/index.vue";
import YC_REQUEST_HANDLER from "@/api/request.js";
import { mapState, mapActions, mapGetters } from 'vuex';
import UTILS from "@/utils/utils.js";
import DBUtils from '@/utils/dbUtils';
import URLSearchParams from 'url-search-params';
import {GetThumb} from '@/utils/productUtil'
export default {
    components: {
        SearchBar,
    },
    computed: {
	    ...mapState({
            user: state => state.user,
            yunModel: state=> state.yunModel
	    }),
	    ...mapGetters({
            login: 'checkLogin',
	    })
	},
    data: function() {
        return {
            limittime_discounts: [],
            PageSize: "",
            CurrentPage: "1",
            flag: "on",
            // 明星航线
            promotionData: "",
            uuid:'',
            day:'',
            hour:'',
            minute:'',
            second:'',
            routeNameList:['欧洲','日韩','北美','东南亚','澳新','非洲','南美','中东'],
            portDB:[],
            listLoading:false,
        };
    },
    mounted: async function() {
        this.portDB = await DBUtils.getDBPorts();
        var vm = this;
        vm.uuid=UTILS.uuid();
        vm.limittimeData();
        // vm.postLog();
        vm.listLoading=true
    },
    methods: {
        toPercent: function(point){
            point=point.toFixed(2)
            if (point==0) {
                return 0;
            }
            if (point==1 || point <=0 ) {
                return '100';
            }
            var str=parseInt(Number(point*100))
            return str;
        },
        // 限时特惠
        limittimeData: function() {
            this.listLoading=true
            var url = "/api/product/query/fla/list",
                formData = {
                    supplierId: ''
                },
                successCallBack = async function(response) {
                    if (response.flashSaleList.length > 0) {
                        _this.limittime_discounts = response.flashSaleList;
                        for (var i = 0; i < _this.limittime_discounts.length; i++) {
                            let temp = _this.limittime_discounts[i];
                            if (temp.flightDate) {
                                temp.endDateTime=temp.flightDate.substring(temp.flightDate.length-5)
                            }
                            temp.productPercentage=_this.toPercent( (temp.transportTotalWeight-temp.transportSurplusWeight) /temp.transportTotalWeight)
                            _this.listLoading=false
                            temp.thumb = GetThumb(temp.routeName, temp.desCityCn, temp.productPercentage == 100 || temp.status == 'OFF')
                        }
                        if (_this.limittime_discounts.length > 18) {
                            _this.limittime_discounts.splice(18);
                        }
                    } else {
                        _this.limittime_discounts = [];
                        _this.listLoading=false
                    }

                },
                failCallBack = function(err) {},
                _this = this;
            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack );
        },
        Immediately: function(
            productcode,
            pricecode,
            productType,
            departure,
            destination
            ) {
            this.$router.push({
                name: "ProductDetailPage",
                query: {
                    productcode: productcode,
                    pricecode: pricecode,
                    productType: productType,
                    departure: departure,
                    destination: destination,
                    yunModel: this.yunModel
                }
            });
        },
        openKF5Support: function () {
            if (window.KF5SupportBoxAPI) {
                window.KF5SupportBoxAPI.open();
            } else {
                window.open('https://efreight.kf5.com/kchat/1039342', '_blank');
                // window.KF5SupportBoxAPI.setAgents([4084194, 5976120], true); //指定客服
            }
        },
        postLog: function () {
            var vm = this;
            var requestFrom = document.referrer;
            if (requestFrom.indexOf("?") > -1) {
                requestFrom = requestFrom.substring(0, requestFrom.indexOf("?"));
            }
            var requestTo = window.location.href;
            if (requestTo.indexOf("?") > -1) {
                requestTo = requestTo.substring(0, requestTo.indexOf("?"));
            }
            var actionType = "LIST";
            var businessCode = "FLA";
            var phoneNo = vm.user.mobile;
            var phoneNoAttribution = "";
            var departure = "";
            var destination = "";
            var productPrice = "";
            var requesterIp = window.sessionStorage.getItem('clientIP');

            var params = new URLSearchParams();
            params.append("requestFrom", requestFrom);
            params.append("requestTo", requestTo);
            params.append("actionType", actionType);
            params.append("businessCode", businessCode);
            params.append("phoneNo", phoneNo);
            params.append("phoneNoAttribution", phoneNoAttribution);
            params.append("departure", departure);
            params.append("destination", destination);
            params.append("productPrice", productPrice);
            params.append("requesterIp", requesterIp);
            YC_REQUEST_HANDLER.LogAccess(params);
        },
    }
};
</script>
